import dayjs from "dayjs";
import { ref, watch } from "vue";
import { useI18n } from "vue-i18n";

type DisabledDates = {
  from?: Date;
  to?: Date;
};

export default function useDateTimeField() {
  const { t } = useI18n();
  const fromDate = ref<string | null>(null);
  const toDate = ref<string | null>(null);
  const fromTime = ref<string | null>(null);
  const toTime = ref<string | null>(null);

  const disabledFromDates = ref<DisabledDates>();
  const disabledToDates = ref<DisabledDates>();

  const fromDateError = ref("");
  const toDateError = ref("");

  const fromTimeError = ref("");
  const toTimeError = ref("");

  const checkFromDate = () => {
    const hasFromtDate = Boolean(fromDate.value);
    const hasFromTime = Boolean(fromTime.value);
    if (!hasFromtDate && hasFromTime) {
      fromDateError.value = t("PleaseInputStartDate");
      return;
    }
    fromDateError.value = "";
  };
  const checkFromTime = () => {
    const hasFromtDate = Boolean(fromDate.value);
    const hasFromTime = Boolean(fromTime.value);
    if (hasFromtDate && !hasFromTime) {
      fromTimeError.value = t("PleaseInputStartTime");
      return;
    }
    fromTimeError.value = "";
  };
  const checkToDate = () => {
    const hasToDate = Boolean(toDate.value);
    const hasToTime = Boolean(toTime.value);
    if (!hasToDate && hasToTime) {
      toDateError.value = t("PleaseInputEndDate");
      return;
    }
    toDateError.value = "";
  };
  const checkToTime = () => {
    const hasToDate = Boolean(toDate.value);
    const hasToTime = Boolean(toTime.value);
    if (hasToDate && !hasToTime) {
      toTimeError.value = t("PleaseInputEndTime");
      return;
    }
    if (fromDate.value !== toDate.value) {
      toTimeError.value = "";
      return;
    }
    // NOTE: from =< Toチェック
    const startDateTime = dayjs(`${fromDate.value} ${fromTime.value}`);
    const endDateTime = dayjs(`${toDate.value} ${toTime.value}`);
    if (startDateTime.isAfter(endDateTime)) {
      toTimeError.value = t("TimePickerEndError");
      return;
    }
    toTimeError.value = "";
  };

  watch(
    () => toDate.value,
    () => {
      const tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);
      tomorrow.setHours(0, 0, 0, 0);
      if (toDate.value) {
        const _toDate = new Date(toDate.value);
        _toDate.setDate(_toDate.getDate() + 1);
        _toDate.setHours(0, 0, 0, 0);
        disabledFromDates.value = {
          from: _toDate,
        };
      } else {
        disabledFromDates.value = {
          from: tomorrow,
        };
      }
      checkToDate();
      checkToTime();
    },
  );

  watch(
    () => fromDate.value,
    () => {
      const tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);
      tomorrow.setHours(0, 0, 0, 0);
      if (fromDate.value) {
        const modifiedStartDate = new Date(fromDate.value);
        modifiedStartDate.setHours(0, 0, 0, 0);
        disabledToDates.value = {
          from: tomorrow,
          to: modifiedStartDate,
        };
      } else {
        disabledToDates.value = {
          from: tomorrow,
        };
      }
      checkFromDate();
      checkFromTime();
      checkToTime();
    },
  );

  watch(
    () => fromTime.value,
    () => {
      checkFromDate();
      checkFromTime();
      checkToTime();
    },
  );

  watch(
    () => toTime.value,
    () => {
      checkToDate();
      checkToTime();
    },
  );

  return {
    fromDate,
    fromTime,
    toDate,
    toTime,
    fromDateError,
    fromTimeError,
    toDateError,
    toTimeError,
    disabledFromDates,
    disabledToDates,
  };
}
